import React, {ReactElement} from 'react';
import ElementButton from '../button/button';
import ElementTextInput from '../input/textInput';
import {IElement} from '../../../../incase-domain/elements';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';

interface ElementTypedProps {
    element: IElement;
    device: DeviceType;
    isLoading: boolean;
    setValidated?: (error: boolean) => void;
    disabled?: boolean;
}

function ElementTyped(props: ElementTypedProps): ReactElement {
    const {element, device, isLoading, setValidated, disabled} = props;
    const {type} = element;

    switch (type) {
        case ELEMENT.BUTTON:
            return <ElementButton device={device} element={element} disabled={disabled || isLoading} showDisabledLoader={isLoading} />;
        case ELEMENT.TEXT_INPUT:
            return <ElementTextInput device={device} element={element} setValidated={setValidated} />;
        default:
            return <div>Undefined element</div>;
    }
}

export default ElementTyped;
